import { render, staticRenderFns } from "./MainSkills.vue?vue&type=template&id=a3d90c50&"
import script from "./MainSkills.vue?vue&type=script&lang=js&"
export * from "./MainSkills.vue?vue&type=script&lang=js&"
import style0 from "./MainSkills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
